export default "__VITE_ASSET__wcvRbdca__"